<template>
    <div>
        <button
            type="button"
            class="btn btn-md is-ghost is-danger"
            href="#"
            @click="$modal.show('deactivate-team')"
        >
            Inaktivera
        </button>
        <adaptive-form-modal
            name="deactivate-team"
            :primary-button-text="buttonText"
            primary-button-class="is-danger"
            title="Inaktivera team"
            :redirect-to="redirectRoute"
            method="patch"
            :action="actionRoute"
        >
            Vill du verkligen inaktivera {{ team.name }}?

            <p class="mt-sm">
                Detta leder till att samtliga säljare i teamet också
                kommer att inaktiveras.
            </p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    import AdaptiveFormModal from '../../../shared/components/Base/Modals/AdaptiveFormModal.vue';

    export default {
        components: {
            AdaptiveFormModal,
        },
        props: {
            team: {
                type: Object,
                required: true,
            },
        },
        computed: {
            buttonText() {
                return `Inaktivera ${this.team.name}`;
            },
            actionRoute() {
                return route('admin.teams.deactivate', this.team);
            },
            redirectRoute() {
                return route('admin.teams.index');
            },
        },
    };
</script>
